import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule, Routes } from '@angular/router';
import { RestModule } from '@ngxp/rest';
import { DashboardModule, DashboardPageComponent } from '@schir-int-client/dashboard';
import { VerfahrenModule } from '@schir-int-client/verfahren';
import { NavbarComponent } from './navbar/navbar.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SettingsMenuComponent } from './navbar/settings-menu/settings-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { UserSettingsDialogComponent } from './navbar/settings-menu/user-settings-dialog/user-settings-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TechModule } from '@schir-int-client/tech';
import { GerichtSettingsDialogComponent } from './navbar/settings-menu/gericht-settings-dialog/gericht-settings-dialog.component';
import { HelpComponent } from './help/help.component';

const routes: Routes = [
	{
		path: 'dashboard',
		component: DashboardPageComponent,
	},
	{
		path: 'admin',
		loadChildren: () => import('@schir-int-client/admin').then(m => m.AdminModule),
	},
];

@NgModule({
	imports: [
		CommonModule,
		RestModule,
		RouterModule.forChild(routes),
		MatToolbarModule,
		MatButtonModule,
		DashboardModule,
		FormsModule,
		VerfahrenModule,
		MatTooltipModule,
		MatMenuModule,
		MatIconModule,
		MatDialogModule,
		TechModule,
		ReactiveFormsModule,
	],
	declarations: [
		NavbarComponent,
		SettingsMenuComponent,
		UserSettingsDialogComponent,
		GerichtSettingsDialogComponent,
		HelpComponent,
	],
	exports: [NavbarComponent, HelpComponent],
})
export class NavbarModule {}
